
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Ano Letivo"
              v-model="form.filters.ano"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <sca-date-picker
            :cols="3"
            label="Data de Início"
            v-model="form.filters.dataInicio"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-date-picker
            :cols="3"
            v-model="form.filters.dataTermino"
            label="Data de Término"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-select-ativo
            :cols="2"
            :config="{
              labelAtivo: 'Ativo',
              labelInativo: 'Inativo',
              label: 'Situação',
            }"
            v-model="form.filters.situacao"
          ></sca-select-ativo>
          <sca-date-picker
            :cols="2"
            label="Data Início"
            v-model="form.filters.dataInicioAcao"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
          <sca-date-picker
            :cols="2"
            v-model="form.filters.dataTerminoAcao"
            label="Data Final"
            removeIcon
            outlined
            dense
          ></sca-date-picker>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios()"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headers"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        :sort-desc="true"
      >
        <template v-slot:[`item.dataInicio`]="{ item }">
          {{ $formatarDataHora(item.dataInicio, 'DD/MM/YYYY') }}
        </template>
        <template v-slot:[`item.dataTermino`]="{ item }">
          {{ $formatarDataHora(item.dataTermino, 'DD/MM/YYYY') }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorio('PDF')"
        @cancel="baixarRelatorio('CSV')"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
import RelatorioDeLogAnoLetivoService from "~/services/relatorios-log/manter-ano-letivo-log.service";
import AnoLetivoService from '~/services/ano-letivo.service';
import DataTableMixin from "~/mixins/datatables.mixin";
import FormatoArquivoEnum from "~/commons/enums/formato-arquivo.enum";

export default {
  name: "RelatorioLogAnoLetivo",
  mixins: [
    RelatorioDeLogAnoLetivoService,
    AnoLetivoService,
    DataTableMixin
  ],
  data: () => ({
    form: {
      filters: {
        dataInicio: null,
        dataTermino: null,
        dataInicioAcao: null,
        dataTerminoAcao: null,
        ano: null,
        situacao: null,
      },
      lists: {
        listRelatorios: [],
      }
    },
    headers: [
      { text: "Ano Letivo", align: "center", value: "ano" },
      { text: "Data de Início", align: "center", value: "dataInicio" },
      { text: "Data de Término", align: "center", value: "dataTermino" },
      { text: "Situação", align: "center", value: "situacao" },
      { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
      { text: "Ação", align: "center", value: "acao" },
    ]
  }),
  methods: {
    async buscarRelatorios() {
      if (this.validarDatas() && this.verificarFiltrosPreenchidos()) {
        const { data } = await this.$obterRelatorioLogAnoLetivo({ params: this.form.filters });
        this.form.lists.listRelatorios = data.lista;
      }
    },
    validarDatas() {
      const { dataInicio, dataTermino } = this.form.filters;
      const { dataInicioAcao, dataTerminoAcao } = this.form.filters;
      if ((dataInicio && dataTermino) || (dataInicioAcao && dataTerminoAcao)) {
        if (new Date(dataTermino) < new Date(dataInicio)) {
          return this.$notifyWarning("A Data de Término não pode ser anterior à Data de Início");
        }
        if (new Date(dataInicioAcao) > new Date(dataTerminoAcao)) {
          return this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
        }
      }
      return true;
    },
    verificarFiltrosPreenchidos() {
      const { dataInicio, dataTermino, dataInicioAcao, dataTerminoAcao, ano, situacao } = this.form.filters;
      if (!ano && situacao == null && !dataInicio && !dataTermino && !dataInicioAcao && !dataTerminoAcao) {
        return this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
      }
      return true;
    },
    async baixarRelatorio(formato) {
      switch (formato) {
        case FormatoArquivoEnum.CSV:
          return this.baixarRelatorioCSV();
        case FormatoArquivoEnum.PDF:
          return this.baixarRelatorioPDF();
        default:
          return this.$notifyWarning("Formato de relatório inválido.");
      }
    },
    async baixarRelatorioCSV() {
      const { data } = await this.$obterRelatorioLogCSVAnoLetivo({ params: this.form.filters });
      this.$baixarRelatorioCSV(data, `SCA.${this.$options.name}${FormatoArquivoEnum.CSV}`, "Operação realizada com sucesso.");
    },
    async baixarRelatorioPDF() {
      const { data } = await this.$obterRelatorioLogPDFAnoLetivo({ params: this.form.filters });
      this.$baixarRelatorioPDF(data, `SCA.${this.$options.name}${FormatoArquivoEnum.PDF}`, "Operação realizada com sucesso.");
    },
    resetForm() {
      this.$clearFilters(this.form);
    }
  },
};
</script>
